import React from 'react';
import { Instagram, Facebook, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-cream pt-24 pb-12 px-6 md:px-12 lg:px-24 border-t border-charcoal/10" data-id="element-95">
      <div className="max-w-7xl mx-auto" data-id="element-96">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20" data-id="element-97">
          {/* Brand Column */}
          <div className="md:col-span-1" data-id="element-98">
            <img src="https://cdn.magicpatterns.com/uploads/n8RBnThdh9nPmMgxYCad5H/PORTADAS_BLOGS_(3).png" alt="Aventuras por el Mundo" className="h-16 w-auto object-contain brightness-0 opacity-90 mb-6" data-id="element-99" />
            <p className="text-sm font-sans text-charcoal/60 leading-relaxed mb-8" data-id="element-100">
              Viajes diseñados exclusivamente para mujeres que buscan
              reconectar, explorar y compartir momentos inolvidables.
            </p>
            <div className="flex space-x-4 text-charcoal/50" data-id="element-101">
              <a href="#" className="hover:text-rose-primary transition-colors" data-id="element-102">
                <Instagram className="w-5 h-5" data-id="element-103" />
              </a>
              <a href="#" className="hover:text-rose-primary transition-colors" data-id="element-104">
                <Facebook className="w-5 h-5" data-id="element-105" />
              </a>
              <a href="#" className="hover:text-rose-primary transition-colors" data-id="element-106">
                <Twitter className="w-5 h-5" data-id="element-107" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div data-id="element-108">
            <h5 className="text-xs font-sans uppercase tracking-[0.2em] text-charcoal/40 mb-6" data-id="element-109">
              Navegación
            </h5>
            <ul className="space-y-4 text-sm font-sans text-charcoal/70" data-id="element-110">
              <li data-id="element-111">
                <a href="#inicio" className="hover:text-rose-primary transition-colors" data-id="element-112">
                  Inicio
                </a>
              </li>
              <li data-id="element-113">
                <a href="#nosotras" className="hover:text-rose-primary transition-colors" data-id="element-114">
                  Nosotras
                </a>
              </li>
              <li data-id="element-115">
                <a href="#experiencias" className="hover:text-rose-primary transition-colors" data-id="element-116">
                  Experiencias
                </a>
              </li>
              <li data-id="element-117">
                <a href="#contacto" className="hover:text-rose-primary transition-colors" data-id="element-118">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Experiencias */}
          <div data-id="element-119">
            <h5 className="text-xs font-sans uppercase tracking-[0.2em] text-charcoal/40 mb-6" data-id="element-120">
              Destinos
            </h5>
            <ul className="space-y-4 text-sm font-sans text-charcoal/70" data-id="element-121">
              <li data-id="element-122">
                <a href="#" className="hover:text-rose-primary transition-colors" data-id="element-123">
                  Sierra Nevada
                </a>
              </li>
              <li data-id="element-124">
                <a href="#" className="hover:text-rose-primary transition-colors" data-id="element-125">
                  Conguillío
                </a>
              </li>
              <li data-id="element-126">
                <a href="#" className="hover:text-rose-primary transition-colors" data-id="element-127">
                  Termas del Sol
                </a>
              </li>
              <li data-id="element-128">
                <a href="#" className="hover:text-rose-primary transition-colors" data-id="element-129">
                  Auroras Boreales
                </a>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div data-id="element-130">
            <h5 className="text-xs font-sans uppercase tracking-[0.2em] text-charcoal/40 mb-6" data-id="element-131">
              Contacto
            </h5>
            <ul className="space-y-4 text-sm font-sans text-charcoal/70" data-id="element-132">
              <li data-id="element-133">hola@aventuras.com</li>
              <li data-id="element-134">+569 1234 5678</li>
              <li data-id="element-135">Santiago, Chile</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-charcoal/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-136">
          <p className="font-sans text-xs text-charcoal/50" data-id="element-137">
            © {new Date().getFullYear()} Aventuras por el Mundo. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-6 font-sans text-xs text-charcoal/50" data-id="element-138">
            <a href="#" className="hover:text-charcoal transition-colors" data-id="element-139">
              Política de privacidad
            </a>
            <a href="#" className="hover:text-charcoal transition-colors" data-id="element-140">
              Términos y condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}